import request from "@/utiles/axios";

/**
 * 查询机构树
 * @param {*} data
 * @returns
 */
export function getDeptTree(data) {
    return request({
      url: "/dept/deptTree",
      method: "post",
      data: data,
    });
  }

/**
* 查询团体成员
* @param {*} data
* @returns
*/
export function groupFarmerList(data) {
  return request({
    url: "/groupFarmer/list",
    method: "post",
    data: data,
  });
}

/**
*删除团体成员
* @param {*} data
* @returns
*/
export function groupFarmerDelete(data) {
  return request({
    url: "/groupFarmer/delete",
    method: "post",
    data: data,
  });
}

/**
*查询穿梭成员
* @param {*} data
* @returns
*/
export function groupFarmerTransfer(data) {
  return request({
    url: "/groupFarmer/transfer",
    method: "post",
    data: data,
  });
}

/**
*新增穿梭成员
* @param {*} data
* @returns
*/
export function groupFarmerAdd(data) {
  return request({
    url: "/groupFarmer/add",
    method: "post",
    data: data,
  });
}

/**
* 查询大团体
* @param {*} data
* @returns
*/
export function groupInfoList(data) {
    return request({
      url: "/groupInfo/list",
      method: "post",
      data: data,
    });
  }

/**
* 新增修改团体信息
* @param {*} data
* @returns
*/
export function groupInfoAddOrUpdate(data) {
    return request({
      url: "/groupInfo/addOrUpdate",
      method: "post",
      data: data,
    });
  }

  /**
 * 删除
 * @param {*} data
 * @returns
 */
  export function groupInfoDelete(id) {
    return request({
      url: `/groupInfo/delete/${id}`,
      method: "get",
    });
  }
